import { useEffect, useState } from 'react';

import { useContentful } from 'react-contentful';

const useContentfulTag = (contentfulTag, contentType = 'General') => {
  const [state, setState] = useState({
    contentful: undefined,
    metadata: undefined,
    sys: undefined,
    error: null,
    fetched: false,
    loading: true,
  });

  const { data, error, fetched, loading } = useContentful({
    contentType,
    query: { 'fields.tag': contentfulTag },
  });

  useEffect(() => {
    if (fetched) {
      setState({
        contentful: data?.items?.[0]?.fields,
        metadata: data?.items?.[0]?.metadata,
        sys: data?.items?.[0]?.sys,
        error,
        fetched,
        loading,
      });
    }
  }, [data, error, fetched, loading]);

  return state;
};

export default useContentfulTag;
